import React, { FunctionComponent as FC } from 'react';


export enum AvatarSizes {
  XS = 'xs', SM = 'sm', MD = 'md', LG = 'lg', XL = 'xl'
}

export interface IAvatarSubject {
  name?: string;
  unknown?: boolean;
  color?: string;
  square?: boolean;
  avatar?: string | { '100x100': string };
  logo?: string | { '100x100': string };

}

export interface IAvatar {
  subject: IAvatarSubject;
  size?: AvatarSizes;
  className?: string;
}

export const Avatar: FC<IAvatar> = ({ subject, className, size }: IAvatar) => {
  const getNameInitials = () => {
    const { name, unknown } = subject;
    if (unknown) return '?';
    if (!name || typeof name !== 'string') return '';
    const names = name.trim().split(' ');
    const lastElem = names[names.length - 1].toUpperCase();
    if (lastElem === 'AS' || lastElem === 'ASA') {
      names.splice(-1, 1);
    }
    return names.length >= 2 ? names[0].charAt(0) + names[1].charAt(0) : names[0].charAt(0) + names[0].charAt(1);
  };

  const avatar = subject.avatar || subject.logo || null;
  const initials = getNameInitials();

  const avatarStyles = avatar
    ? {
      backgroundImage: `url(${avatar})`,
      backgroundSize: 'cover',
      backgroundColor: 'transparent',
    }
    : subject.unknown
      ? { backgroundColor: '#F4F4F6', color: '#8f8f90' }
      : subject.color
        ? { backgroundColor: subject.color }
        : initials.length === 1
          ? { fontSize: '1.4rem' }
          : {};

  return (
    <div className={`avatar avatar-${size} ${className || ''}`}>
      <span
        className={`avatar-title w-100 ${!subject.square && 'rounded-circle'} ${!!subject.square && 'rounded'}`}
        style={avatarStyles}
      >
        {!avatar && initials}
      </span>
    </div>
  );
};

Avatar.defaultProps = {
  size: AvatarSizes.MD,
};

export default Avatar;
